<template>
  <v-container id="employee-report" fluid tag="section">
    <filter-form
        :currentPage="currentPage"
        :limit="limit"
        :filterForm="filterForm" 
        :agencies="agencies"
    />
    <v-card>
      <EmployeeReportTable
        :employeeReports="employeeReports" :totalReports="totalReports" :roleName="roleName"
      />
      <common-no-result
        v-if="!employeeReports.length || totalItem === 0"
      />
      <v-row class="mt-4">
        <v-col
            cols="12"
            sm="6"
        />
        <v-col
            cols="12"
            sm="6"
        >
          <v-pagination
            v-if="totalItem > limit"
            v-model="currentPage"
            class="justify-sm-end"
            :length="getTotalItem(totalItem, limit)"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
          />
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import TokenService from '../../../../helpers/token';
import * as moment from 'moment'
import FilterForm from './components/FilterForm.vue'
import EmployeeReportTable from './components/EmployeeReportTable'
import { formatDate } from '@/helpers/utils'
import RepositoryFactory from "@/repositories/RepositoryFactory";
const AgencyRepository = RepositoryFactory.get('agency')

export default {
  components: { FilterForm, EmployeeReportTable },
  data () {
    return {
      employeeReports: [],
      filterForm: {
        dateRange: {
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
        },
        agencyId: []
      },
      currentPage: 1,
      limit: 10,
      totalItem: 0,
      errorMessage: '',
      loading: false,
      totalReports: {},
      roleName: _.get(TokenService.getUser(), 'role.name', ''),
      watchModule: '',
      agencies: []
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getEmployeeReport()
      }
    },
    limit: {
      handler() {
        if (this.currentPage === 1) {
          this.getEmployeeReport()
        } else {
          this.currentPage = 1
        }
      }
    }
  },
  created () {
    this.getListAgency()
    this.getEmployeeReport()
    Bus.$on('agency-report-list-filter', (filterForm) => {
      this.filterForm = filterForm
      this.getEmployeeReport()
      this.currentPage = 1
    })

    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.filterForm = {
          dateRange: {
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
          },
          agencyId: []
        }
      
        Bus.$emit('agency-report-list-filter', this.filterForm)
      },
      {
        deep: true
      }
    )
  },
  beforeDestroy() {
    Bus.$off('agency-report-list-filter');
    this.watchModule()
  },

  methods: {
    async getEmployeeReport () {
      const params = {
        startDate: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD'),
        endDate: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD'),
        agencyId: this.filterForm.agencyId,
        page: this.currentPage - 1,
        limit: this.limit
      }

      const loader = this.$loading.show()
      const response = await AgencyRepository.getEmployeeReport(params)
      if (response.success) {
        this.employeeReports = _.get(response, 'data.rows', [])
        this.totalItem = _.get(response, 'data.count', 0)
        this.totalReports = _.get(response, 'data.total', {})
      }
      loader.hide()
    },

    async getListAgency() {
      // Danh sách đại lý
      const res = await AgencyRepository.list({
        limit: 100
      })

      if (res.success) {
        this.agencies = _.get(res, 'data', [])
      } else {
        this.agencies = []
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    }
  },
}
</script>
